import React from 'react';
import rehypeReact from 'rehype-react';
import styled from 'styled-components';
import { FormattedMessage, injectIntl } from 'react-intl';

import ContactForm from '../components/ContactForm';
import ExhibitorsList from '../components/ExhibitorsList';
import Content from '../layouts/components/Content';
import { breakpoints } from '../constants';

import background from './assets/page-header-backgound.jpg';

import { RUVWidget } from './ruvents';

const Title = styled.div`
    color: white;
    margin-left: 200px;
    @media (max-width: ${breakpoints.tablet}) {
        margin-left: 0;
        order: 2;
        min-width: 60%;
    }
    @media (max-width: ${breakpoints.mobile}) {
        h3 {
            font-size: 1.5rem !important;
        }
    }
`;

const Dates = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 200px;
    font-size: 1.42rem;
    font-weight: bold;
    color: white;
    @media (max-width: ${breakpoints.tablet}) {
        order: 1;
        margin: 0 0 30px 0;
    }
    @media (max-width: ${breakpoints.mobile}) {
        font-size: 1.1rem;
    }
`;

const Numbers = styled.div`
    flex: 1;
    color: white;
    font-size: 3.5rem;
    line-height: 3.5rem;
    font-weight: normal;
    margin-right: 10px;
    @media (max-width: ${breakpoints.mobile}) {
        font-size: 2.5rem;
    }
`;

const Place = styled.div`
    font-size: 80%;
`;

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 146px;
    background: url(${background}) center center no-repeat no-repeat;
    background-size: cover;
    @media (max-width: ${breakpoints.tablet}) {
        flex-wrap: wrap;
        height: auto;
        padding: 40px 30px;
    }
    @media (max-width: ${breakpoints.mobile}) {
        justify-content: center;
    }
`;

const Banners = styled.div`
    width: 250px;
    margin-left: 100px;
    @media (max-width: ${breakpoints.tablet}) {
        display: ${({ hasBanners }) => (hasBanners ? 'block' : 'none')};
        margin-left: 20px;
        width: 35%;
        max-width: 250px;
    }
    @media (max-width: ${breakpoints.mobile}) {
        margin-left: 30px;
        width: 100%;
        text-align: center;
    }
`;

const ContentWrapper = styled.div`
    display: flex;
    padding: 60px 200px;
    @media (max-width: ${breakpoints.tablet}) {
        // display: block;
        padding: 30px;
    }
`;

const renderAst = new rehypeReact({
    createElement: React.createElement,
    components: {
        'contact-form': ContactForm,
    },
}).Compiler;

class Template extends React.PureComponent {
    componentDidMount() {
        if (this.props.data.article.slug === 'registration' && window.easyXDM) {
            var widgets = document.querySelectorAll('.ruv-widget');
            for (var i = 0; i < widgets.length; i++) {
                var widget = widgets[i];
                new RUVWidget(widget);
            }
        }
    }

    render() {
        const {
            article,
            exhibitors,
            exhibitorsImages,
            banners,
        } = this.props.data;
        const htmlAst =
            article.content && article.content.childMarkdownRemark.htmlAst;
        const isExhibitorsListPage =
            this.props.location &&
            /\/pages\/exhibitors-list/.test(this.props.location.pathname);

        return (
            <section>
                <Header>
                    <Title>
                        <h3 className="title is-3" style={{ color: 'white' }}>
                            {article.title}
                        </h3>
                    </Title>
                    <Dates>
                        <Numbers>12•13•14</Numbers>
                        <div style={{ fontSize: '80%' }}>
                            <div>
                                <FormattedMessage id="header.dates.date" />
                            </div>
                            <Place>
                                <FormattedMessage id="header.dates.place" />
                            </Place>
                        </div>
                    </Dates>
                </Header>
                <ContentWrapper>
                    <Content className="content">
                        {htmlAst && renderAst(htmlAst)}
                        {isExhibitorsListPage && (
                            <ExhibitorsList
                                exhibitors={exhibitors.edges}
                                logos={exhibitorsImages.edges}
                            />
                        )}
                    </Content>
                    <Banners hasBanners={!!banners}>
                        {banners &&
                            banners.edges.map(({ node }, idx) => (
                                <div key={idx} style={{ marginBottom: 40 }}>
                                    <a href={node.link} target="_blank">
                                        <img
                                            style={{ width: '100%' }}
                                            src={node.banner.file.url}
                                        />
                                    </a>
                                </div>
                            ))}
                    </Banners>
                </ContentWrapper>
            </section>
        );
    }
}

export default injectIntl(Template);

export const pageQuery = graphql`
    query pageQuery($id: String!, $slug: String!, $locale: String!) {
        article: contentfulArticle(id: { eq: $id }) {
            slug
            title
            content {
                childMarkdownRemark {
                    htmlAst
                }
            }
        }
        ...Exhibitors
        banners: allContentfulBanner(
            filter: { page: { in: ["*", $slug] }, node_locale: { eq: $locale } }
        ) {
            edges {
                node {
                    link
                    banner {
                        file {
                            url
                        }
                    }
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/templates/pageTemplate.js